import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const upload = params => {
  const payload = new FormData();
  payload.append('file', params.file);
  return ApiService.post('file', payload);
};
